import { render } from "./UserLogout.vue?vue&type=template&id=2c2ca82c&scoped=true"
import script from "./UserLogout.vue?vue&type=script&lang=js"
export * from "./UserLogout.vue?vue&type=script&lang=js"

import "./UserLogout.vue?vue&type=style&index=0&id=2c2ca82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2ca82c"]])

export default __exports__